import { Action, Notification } from './notification.types'

export const notificationReducer = (
  notifications: Notification[],
  action: Action
): Array<Notification> => {
  switch (action.type) {
    case 'ADD':
      return action.payload.id &&
        notifications.some((notification) => notification.id === action.payload.id)
        ? notifications
        : [...notifications, action.payload]
    case 'REMOVE':
      return notifications.filter((n) => n.id !== action.id)
    default:
      throw new Error('Unexpected action in notification reducer')
  }
}
